import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ role, roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm font-heading">Caricamento…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Forced password change after reset: bloccala fino al cambio
  if (user.must_change_password && location.pathname !== "/cambio-password") {
    return <Navigate to="/cambio-password" replace />;
  }
  const allowed = roles ? roles.includes(user.role) : (role ? user.role === role : true);
  if (!allowed) {
    const fallback = user.role === "platform_admin"
      ? "/master"
      : user.role === "agente"
      ? "/admin"
      : "/foglio-cassa";
    return <Navigate to={fallback} replace />;
  }
  return children;
}
